import translations, {Locale} from './translations';

export type Translator = (
  key: keyof typeof translations,
  variables?: Record<string, string>
) => string;

export function translate(
  locale: Locale,
  key: keyof typeof translations,
  variables: Record<string, string> = {}
): string {
  let text: string = translations[key]?.[locale] ?? translations[key]?.['en'] ?? key;

  // Replace variables in the format {{variableName}}
  Object.entries(variables).forEach(([varName, value]) => {
    text = text.replaceAll(`{{${varName}}}`, () => value);
  });

  return text;
}
